<template>
  <FormFieldset
    :label="label"
    :patternLabel="patternLabel"
    :description="description"
    :error="error"
    :errorMessage="errorMessage"
    :req="req"
    :optional="optional"
  >
    <div class="formSelect" :class="`-${size}`">
      <Selectbox
        :id="id"
        :name="name"
        :options="items"
        :addClass="{}"
        :req="req || formGroupReq"
        :disabled="disabled"
        :value="value"
        :error="error"
        @selection-change="changeSelect($event)"
      />
    </div>
  </FormFieldset>
</template>

<script lang="ts">
import FormFieldset from '@/components/block/FormFieldset.vue'
import Selectbox from '@/components/elements/InputSelectbox.vue'
import { SetupContext } from 'vue'

export default {
  name: 'FormSelectField',

  components: {
    FormFieldset,
    Selectbox
  },

  props: {
    value: String,
    id: String,
    name: String,
    items: Array,
    size: String,
    label: {
      type: String,
      default: 'ラベル',
      required: true
    },
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    formGroupReq: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    description: String,
    errorMessage: String,
    error: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any, context: SetupContext) {
    const changeSelect = (value: string) => {
      context.emit('change-message', value)
    }

    return {
      changeSelect
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.formSelect {
  margin-left: -7px;
  margin-right: -7px;
}
</style>
